import { useRouter } from 'next/router';
import ChooseLogin from '../../components/checkout/choose-login';
import Loading from '../../components/common/loading';
import { MaxContainer } from '../../components/layout/container';
import Layout from '../../components/layout/layout';
import { useUser } from '../../components/user-context';

const Profile = ({ preview }) => {
  const { userInitialized, isLoggedIn } = useUser();
  const router = useRouter();

  const advance = () => {
    router.push('/checkout/review');
  };

  if (userInitialized && isLoggedIn) {
    advance();
  }

  return (
    <Layout preview={preview} robots='noindex'>
      {userInitialized && !isLoggedIn ? (
        <ChooseLogin className='mt-10' advance={advance} />
      ) : (
        <MaxContainer className='mt-10'>
          <Loading />
        </MaxContainer>
      )}
    </Layout>
  );
};

export default Profile;

export async function getStaticProps({ preview = false }) {
  return {
    props: { preview },
  };
}
